import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
//import { Features } from "./components/features";
import { About } from "./components/about";
//import { Services } from "./components/services";
//import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import { Premed } from "./components/premed";
import { Predent } from "./components/predent";
import { Prepa } from "./components/prepa";
import { EventsPage } from "./components/EventsPage";
import { MeetTheTeamPage } from "./components/MeetTheTeamPage";
import { LocationsPage } from "./components/LocationsPage";
import { GetInvolvedPage } from "./components/GetInvolvedPage";
import JsonData from "./data/data.json";
import "./App.css";
import { scrollToHash } from "./utils/scroll";


const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  // Smooth scroll when URL has a hash: on load and when hash changes (nav link clicked)
  useEffect(() => {
    let timeoutId = null;

    const runScroll = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(scrollToHash, 150);
    };

    if (window.location.hash) runScroll();

    window.addEventListener("hashchange", runScroll);
    return () => {
      window.removeEventListener("hashchange", runScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Router>
      <div>
        <Navigation />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header data={landingPageData.Header} />
                <About data={landingPageData.About} />
                <Contact data={landingPageData.Contact} />
              </>
            }
          />
          <Route path="/premed" element={<Premed data={landingPageData.Premed} />} />
          <Route path="/predent" element={<Predent data={landingPageData.Predent} />} />
          <Route path="/prepa" element={<Prepa data={landingPageData.Prepa} />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/meet-the-team" element={<MeetTheTeamPage presidentsData={landingPageData.Presidents} />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/get-involved" element={<GetInvolvedPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
